import { Box, Typography } from '@mui/material'
import React from 'react'
import { useStyles } from './styles'
import { ExecutionCardProps } from './types'
import { CustomPaper } from '../../../../../../components/CustomPaper'
import { KeyCaption } from '../keyCaption'
import { KeyCaptionPercentage } from '../keyCaptionPercentage'

export const ExecutionCard = ({ title, options, margin, percentage: isPercentage }: ExecutionCardProps) => {
    const styles = useStyles({ margin })
    return (
        <CustomPaper id={'3'} elevation={3}>
            <Box sx={styles.container}>
                <Typography sx={styles.title}>{title}</Typography>
                <Box sx={styles.display}>
                    {options?.map(({number, percentage, text, }, index) => {
                        if (isPercentage) { return <KeyCaptionPercentage percentage={percentage}  key={index} number={number} text={text} /> }
                        return <KeyCaption key={index} number={number} text={text} />
                    })}
                </Box>
            </Box>
        </CustomPaper>
    )
}
